interface IProfileProps {
  name: string;
  title: string;
  company: string;
  description: any;
  avatarUrl: string;
}

export default function Profile({ name, title, company, description, avatarUrl }: IProfileProps) {
  return (
    <div className="p-4 bg-white rounded-md max-w-4xl max-h-[500px] overflow-auto font-lato">
      <p className="text-lg font-bold">{name}</p>
      <p className="text-base font-bold mt-2">{title}</p>
      <p className="text-base font-bold mt-1">{company}</p>

      <div className="mt-4 flex">
        <img src={avatarUrl} className="w-52 h-52 rounded-lg" />
        <p
          className="ml-4 text-sm whitespace-pre-line min-w-[200px]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
}
